export default {
    manageTemplates: 'Manage Templates',
    headerCard: {
        title: 'Build your Questionnaire',
        description:
            'Choose how you want to build your questionnaire - start from scratch or use one of our proven templates',
    },
};
